

export const QUESTION_IDS = {  
  ID_MICRO: "247c7259-43b1-4f41-811b-9ae83a2faec8",
  ID_DESTINATARIOS: "a71fb685-4936-4ec2-8c65-19ea44390ba1",
  ID_ARTICULACION: "40444b62-ae9c-4548-821e-62bb82a8e16f"
};